export default __webpack_public_path__ + "static/media/UNI.6982cfe0.png";